import AppointmentsDetails from "./AppointmentsDetails"

export default function AppointmentsTab({ subscribeRemoteList = true }) {
    return (
        <div>
            <AppointmentsDetails subscribeRemoteList={subscribeRemoteList} />
        </div>
    )
}